import { UrgentRequestsOverview } from '../../components/urgent-requests/UrgentRequestsOverview';

export const UrgentRequestsOverviewView = () => <UrgentRequestsOverview />;
